import { useRef } from "react";
import { Controller } from "react-hook-form";
import { UploadCloud, FileText } from "lucide-react";
import axios from "axios";
import { ENVIRONMENT } from "../../../../environment/environment";
import { Button } from "../../ui";

export function InputFileUpload({
  name,
  label,
  methods,
  disabled,
  helperText,
  acceptedFormats = ".pdf,.jpg,.png",
  required,
}: {
  name: string;
  label: string;
  methods: any;
  disabled?: boolean;
  helperText?: string;
  required?: boolean;
  acceptedFormats?: string;
}) {
  const baseUrl = ENVIRONMENT.BASE_URL_API;
  const uploadUrl = baseUrl + "/upload"; // URL fixa
  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleUpload = async (file: File, onChange: (value: any) => void) => {
    const formData = new FormData();
    formData.append("file", file);
    try {
      const response = await axios.post(uploadUrl, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      // Supondo que a API retorna { fileName, path }
      onChange(response.data.path); // Salva só o path no form
    } catch (e) {
      alert("Erro ao enviar arquivo");
    }
  };

  return (
    <Controller
      name={name}
      control={methods.control}
      render={({ field, fieldState: { error } }) => (
        <div>
          <Button
            type="button"
            variant={error ? "danger" : "outline"}
            disabled={disabled}
            startIcon={<UploadCloud className="h-4 w-4" />}
            onClick={() => fileInputRef.current?.click()}
          >
            {label}
          </Button>
          <input
            ref={fileInputRef}
            type="file"
            hidden
            accept={acceptedFormats}
            disabled={disabled}
            onChange={async (e) => {
              const file = e.target.files?.[0];
              if (file) {
                await handleUpload(file, field.onChange);
              }
            }}
          />

          {field.value && (
            <div className="mt-2 flex items-center gap-1.5 text-sm">
              <FileText className="h-4 w-4 text-slate-400" />
              <span className="text-slate-500 dark:text-slate-400">
                Arquivo enviado:
              </span>
              <a
                href={baseUrl + "/" + field.value}
                rel="noopener noreferrer"
                download
                target="_blank"
                className="font-medium text-primary-600 hover:underline dark:text-primary-400"
              >
                {typeof field.value === "string"
                  ? field.value.split("/").pop()
                  : "Arquivo"}
              </a>
            </div>
          )}

          {error ? (
            <p className="mt-1.5 text-xs text-red-500">{error.message}</p>
          ) : (
            <>
              {required && (
                <p className="mt-1.5 text-xs text-slate-500 dark:text-slate-400">
                  *O arquivo é obrigatório.
                </p>
              )}
              {helperText && (
                <p className="text-xs text-slate-500 dark:text-slate-400">
                  {helperText}
                </p>
              )}
            </>
          )}
        </div>
      )}
    />
  );
}

